import { enableProdMode, provideAppInitializer } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { CosBootstrapState } from '@cosmos/core';
import { loadPolyfills } from '@cosmos/polyfills';

import { AppRootComponent } from './app/app-root.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

loadPolyfills({ zoneless: true });

async function bootstrap() {
  // eslint-disable-next-line no-restricted-globals
  await window.cosCanBootstrapPromise;
  const { injector } = await bootstrapApplication(AppRootComponent, {
    providers: [
      ...appConfig.providers,
      provideAppInitializer(
        () => new Promise((resolve) => setTimeout(resolve))
      ),
    ],
  });
  injector.get(CosBootstrapState).bootstrap();
}

bootstrap();
